module.exports = __webpack_public_path__ + "img/ecart-logo.9a77a111.png";